export default "__VITE_ASSET__B8$k8MtC__"